import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Card,
  CardContent,
  Grid,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Button,
} from "@mui/material";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import { EditIcon } from "../comps/CustomIcons";
import PrintIcon from "@mui/icons-material/Print";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useNavigate, useParams } from "react-router-dom";
import { axiosCall } from "../utils/axiosCall";
import constants from "../config/constants";
import { useSelector } from "react-redux";
import CloseIcon from "@mui/icons-material/Close";
import dayjs from "dayjs";

function PatientAppointments(props) {
  const {setAppointmentData} = props;
  const user = useSelector((state) => state.user);
  const { patientId } = useParams();
  const navigate = useNavigate();

  // const [patientInfo, setPatientInfo] = React.useState([
  //   {
  //     appointment: {
  //       _id: "67d99e757ee52e80139266f8",
  //       UHID: "398171",
  //       patientId: {
  //         _id: "6717808432b7f19c0f45ec32",
  //         firstName: "lincon",
  //         lastName: "matthew",
  //       },
  //       unit: {
  //         _id: "67adb631a57216e48aa1199f",
  //         unitName: "Gastro",
  //       },
  //       doctorName: {
  //         _id: "67c87e13846b8747ad576456",
  //         firstName: "Sayan",
  //         lastName: "Sadhukhan",
  //       },
  //       visitType: {
  //         _id: "67af489b74b7d9ea8be46e8e",
  //         name: "New",
  //       },
  //       appointmentDateTime: "2025-03-18T22:00:00.000Z",
  //       paymentStatus: "paid",
  //       status: "scheduled",
  //       createdBy: {
  //         _id: "67aa3a40f1c33f817cdcae8b",
  //         firstName: "Vipul",
  //         lastName: "Kumar",
  //       },
  //     },
  //     invoices: [
  //       {
  //         _id: "67d99e767ee52e80139266fb",
  //         invoiceNumber: "APP/18/03/25/398171/1713",
  //         invoiceDate: "2025-03-18T16:25:26.016Z",
  //         netAmount: 200,
  //         totalAmount: 200,
  //         closingDate: "2025-03-18T16:25:26.529Z",
  //         status: "Closed",
  //       },
  //     ],
  //   },
  //   {
  //     appointment: {
  //       _id: "67d99e757ee52e80139266f9",
  //       UHID: "398171",
  //       patientId: {
  //         _id: "6717808432b7f19c0f45ec32",
  //         firstName: "lincon",
  //         lastName: "matthew",
  //       },
  //       unit: {
  //         _id: "67adb631a57216e48aa1199f",
  //         unitName: "ENT",
  //       },
  //       doctorName: {
  //         _id: "67c87e13846b8747ad576456",
  //         firstName: "Sayan",
  //         lastName: "Saha",
  //       },
  //       visitType: {
  //         _id: "67af489b74b7d9ea8be46e8e",
  //         name: "New",
  //       },
  //       appointmentDateTime: "2025-03-18T22:00:00.000Z",
  //       paymentStatus: "paid",
  //       status: "re-scheduled",
  //       createdBy: {
  //         _id: "67aa3a40f1c33f817cdcae8b",
  //         firstName: "Vipul",
  //         lastName: "Kumar",
  //       },
  //     },
  //     invoices: [
  //       {
  //         _id: "67d99e767ee52e80139266fb",
  //         invoiceNumber: "APP/18/03/25/398171/1317",
  //         invoiceDate: "2025-03-18T16:25:26.016Z",
  //         netAmount: 200,
  //         totalAmount: 200,
  //         closingDate: "2025-03-18T16:25:26.529Z",
  //         status: "Closed",
  //       },
  //     ],
  //   },
  // ]);
  const [patientInfo, setPatientInfo] = React.useState([]);
  const [selectedIndex, setSelectedIndex] = React.useState(0);
  const [isEdit, setIsEdit] = useState(false);
  const [appointmentList, setAppointmentList] = useState([]);

  useEffect(() => {
    // Initialize appointmentList with the first appointment's invoice data
    setAppointmentData(patientInfo[selectedIndex]?.appointment?._id || "")
  }, [patientInfo, selectedIndex]);
  // Function to add a new row
  const handleAddTableRow = () => {
    setAppointmentList((prev) => [
      ...prev,
      {
        id: prev.length + 1,
        invoiceNo: "",
        billNo: "",
        generatedOn: "",
        closedOn: "",
        amountToBePaid: "",
      },
    ]);
  };

  // Function to remove a row
  const handleRemoveTableRow = (id) => {
    setAppointmentList((prev) => prev.filter((row) => row.id !== id));
  };
  useEffect(() => {
    if (patientId) {
      fetchPatient(patientId);
    }
  }, [patientId]);
  const fetchPatient = async () => {
    try {
      const getPatient = await axiosCall(
        constants.GET_METHOD,
        constants.GET_PATIENT_APPOINTMENT + `/${patientId}`,

        null,
        null,
        user.token
      );

      if (getPatient.isSuccess) {
        // console.log(getPatient?.data?.appointments);
        setPatientInfo(getPatient?.data?.appointments);
        setSelectedIndex(0);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const handleBoxClick = (index) => {
    setSelectedIndex(index); // Only update the selected index
  };
  // const appointmentData = {
  //   consultationType: "OPD",
  //   department: "Gynae",
  //   doctorName: "Dr. Mira Roy",
  //   visitType: "New",
  //   billNo: "02/06/22/84723682",
  //   appointmentDate: "02/06/2022",
  //   paymentStatus: "Completed",
  //   appointmentStatus: "Converted",
  //   createdBy: "Anish Mahato",
  //   createdOn: "02/06/2022 | 09:25",
  //   invoiceNo: "OPD/84327278",
  //   generatedOn: "02/06/22",
  //   closedOn: "-",
  //   amountToBePaid: "₹520.00",
  // };
  const selectedAppointment = patientInfo[selectedIndex]?.appointment || {};

  const appointmentData = {
    appointmentId: selectedAppointment?._id,
    consultationType: selectedAppointment?.visitType?.name || "",
    department: selectedAppointment?.unit?.unitName || "",
    doctorName: `${selectedAppointment?.doctorName?.firstName || ""} ${
      selectedAppointment?.doctorName?.lastName || ""
    }`,
    paymentStatus: selectedAppointment?.paymentStatus || "",
    visitType: selectedAppointment?.visitType?.name || "",
    billNo: patientInfo[selectedIndex]?.invoices?.[0]?.invoiceNumber || "",
    appointmentDate: selectedAppointment?.appointmentDateTime
      ? `${dayjs(selectedAppointment?.appointmentDateTime).format("DD/MM/YYYY, hh:mm A")}`
      : "-",
    appointmentStatus: selectedAppointment?.status || "",
    createdBy: `${selectedAppointment?.createdBy?.firstName || ""} ${
      selectedAppointment?.createdBy?.lastName || ""
    }`,
    createdOn: selectedAppointment?.createdAt
      ? `${dayjs(selectedAppointment?.createdAt).format("DD/MM/YYYY, hh:mm A")}`
      : "-",
    invoiceNo: patientInfo[selectedIndex]?.invoices?.[0]?.invoiceNumber || "",
    generatedOn: patientInfo[selectedIndex]?.invoices?.[0]?.invoiceDate
      ? dayjs(patientInfo[selectedIndex]?.invoices?.[0]?.invoiceDate).format("DD/MM/YYYY")
      : "-",
    closedOn: patientInfo[selectedIndex]?.invoices?.[0]?.closingDate
      ? dayjs(patientInfo[selectedIndex]?.invoices?.[0]?.closingDate).format("DD/MM/YYYY")
      : "-",
    amountToBePaid: patientInfo[selectedIndex]?.invoices?.[0]?.netAmount,
  };

  return (
    <Box sx={{ width: "100%" }}>
      {/* Appointments */}

      <Box
        sx={{
          padding: 2,
          marginTop: 2,
          borderRadius: 2,
          backgroundColor: "#f5faff",
        }}
      >
        <Grid container spacing={2}>
          {/* Appointments Section */}
          <Grid item xs={4}>
            <Typography variant="h6" sx={{ mb: 2, color: "#556080" }}>
              Appointments
            </Typography>
            <Card
              variant="outlined"
              sx={{ maxHeight: "240px", overflow: "auto" }}
            >
              <CardContent>
                {patientInfo?.map((info, index) => (
                  <Box
                    key={info?._id}
                    sx={{
                      p: 2,
                      border: "1px solid #d5d9e3",
                      borderRadius: 1,
                      mb: 2,
                      bgcolor: selectedIndex === index ? "#e8effb" : "white", // Change color when selected
                      cursor: "pointer",
                    }}
                    onClick={() => handleBoxClick(index)}
                  >
                    <Typography variant="body1" fontWeight="bold">
                      {info?.appointment?.unit?.unitName} |{" "}
                      <Typography
                        component="span"
                        color={
                          info?.appointment?.status === "scheduled" ||
                          info?.appointment?.status === "re-scheduled"
                            ? "yellowgreen"
                            : "red"
                        }
                      >
                        {info?.appointment?.status === "scheduled" ||
                        info?.appointment?.status === "re-scheduled"
                          ? "Open"
                          : info?.appointment?.status === "cancelled" ||
                            info?.appointment?.status === "converted" ||
                            info?.appointment?.status === "completed"
                          ? "Close"
                          : null}
                      </Typography>
                    </Typography>
                    <Typography variant="body2">
                      {info?.appointment?.doctorName?.firstName || "-"}{" "}
                      {info?.appointment?.doctorName?.lastName || "-"}
                    </Typography>
                    <Typography variant="body2">
                      {info?.appointment?.appointmentDateTime
                        ? `${dayjs(
                            info?.appointment?.appointmentDateTime
                          ).format("DD/MM/YYYY, hh:mm A")}`
                        : ""}
                    </Typography>
                  </Box>
                ))}
              </CardContent>
            </Card>
          </Grid>

          {/* Appointment Details Section */}
          <Grid item xs={8}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                py: "10px",
              }}
            >
              <Typography variant="h6" sx={{ mb: 2, color: "#556080" }}>
                Appointment Details
              </Typography>
              {(appointmentData?.appointmentStatus === "scheduled" ||
                appointmentData?.appointmentStatus === "re-scheduled") && (
                <Button
                  variant="contained"
                  sx={{ textTransform: "none" }}
                  onClick={() =>
                    navigate(
                      `/patient/convert-consultation-opd/${appointmentData?.appointmentId}`
                    )
                  }
                >
                  Convert Consultation
                </Button>
              )}
            </Box>
            <Card variant="outlined">
              <CardContent>
                {/* <Box display="flex" justifyContent="flex-end">
                  <IconButton onClick={() => setIsEdit(true)}>
                    <EditIcon
                      sx={{
                        cursor: "pointer",
                        color: "transparent",
                        fontSize: "18px",
                      }}
                    />
                  </IconButton>
                </Box> */}
                <Grid container spacing={2}>
                  <Grid item xs={3}>
                    <Typography variant="body2" color="textSecondary">
                      Consultation Type
                    </Typography>
                    <Typography variant="body1">
                      {appointmentData.consultationType || "-"}
                    </Typography>
                  </Grid>
                  <Grid item xs={3}>
                    <Typography variant="body2" color="textSecondary">
                      Department
                    </Typography>
                    <Typography variant="body1">
                      {appointmentData.department || "-"}
                    </Typography>
                  </Grid>
                  <Grid item xs={3}>
                    <Typography variant="body2" color="textSecondary">
                      Doctor's Name
                    </Typography>
                    <Typography variant="body1">
                      {appointmentData.doctorName}
                    </Typography>
                  </Grid>
                  <Grid item xs={3}>
                    <Typography variant="body2" color="textSecondary">
                      Payment Status
                    </Typography>
                    <Typography variant="body1">
                      {appointmentData.paymentStatus || "-"}
                    </Typography>
                  </Grid>
                  <Grid item xs={3}>
                    <Typography variant="body2" color="textSecondary">
                      Visit Type
                    </Typography>
                    <Typography variant="body1">
                      {appointmentData.visitType || "-"}
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="body2" color="textSecondary">
                      Bill No.
                    </Typography>
                    <Typography variant="body1">
                      {appointmentData.billNo || "-"}
                    </Typography>
                  </Grid>
                  <Grid item xs={3}>
                    <Typography variant="body2" color="textSecondary">
                      Appointment Date
                    </Typography>
                    <Typography variant="body1">
                      {selectedAppointment?.appointmentDateTime
                        ? `${dayjs(selectedAppointment?.appointmentDateTime).format("DD/MM/YYYY, hh:mm A")}`
                        : "-"}
                    </Typography>
                  </Grid>
                  <Grid item xs={3}>
                    <Typography variant="body2" color="textSecondary">
                      Appointment Status
                    </Typography>
                    <Typography variant="body1">
                      {appointmentData.appointmentStatus || "-"}
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="body2" color="textSecondary">
                      Created By
                    </Typography>
                    <Box display="flex" alignItems="center">
                      <Typography variant="body1">
                        {appointmentData.createdBy} |
                      </Typography>
                      <Typography variant="body2">
                        &nbsp;{appointmentData.createdOn}
                      </Typography>
                    </Box>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>

          {/* Bills Section */}
          <Grid item xs={12}>
            <Card variant="outlined">
              <CardContent>
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  mb={2}
                >
                  <Typography variant="h6" sx={{ color: "#556080" }}>
                    Bills
                  </Typography>
                  {/* <IconButton>
                    <PrintIcon fontSize="small" />
                  </IconButton> */}
                </Box>
                {/* <Divider sx={{ my: 2 }} /> */}
                <TableContainer
                  sx={{ border: "1px solid #d5d9e3", borderRadius: 2 }}
                >
                  <Table>
                    {/* Table Head */}
                    <TableHead>
                      <TableRow>
                        <TableCell>Invoice No.</TableCell>
                        <TableCell>Bill No.</TableCell>
                        <TableCell>Generated On</TableCell>
                        <TableCell>Closed On</TableCell>
                        <TableCell>Amount To Be Paid</TableCell>
                        {isEdit && <TableCell align="center">Action</TableCell>}
                      </TableRow>
                    </TableHead>

                    {/* Table Body */}
                    <TableBody>
                      {/* Static Data Row */}
                      <TableRow>
                        <TableCell>
                          {appointmentData.invoiceNo || "-"}
                        </TableCell>
                        <TableCell>{appointmentData.billNo || "-"}</TableCell>
                        <TableCell>
                          {appointmentData.generatedOn || "-"}
                        </TableCell>
                        <TableCell>{appointmentData.closedOn || "-"}</TableCell>
                        <TableCell>
                          {patientInfo[selectedIndex]?.invoices?.[0]?.totalAmount || "-"}
                        </TableCell>
                        {isEdit && (
                          <TableCell
                            sx={{
                              textAlign: "right",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "flex-end",
                              gap: 1,
                            }}
                          >
                            <IconButton>
                              <RemoveRedEyeOutlinedIcon />
                            </IconButton>
                            <IconButton>
                              <EditIcon
                                sx={{
                                  cursor: "pointer",
                                  color: "transparent",
                                  fontSize: "18px",
                                }}
                              />
                            </IconButton>
                            <IconButton>
                              <CloseIcon fontSize="small" />
                            </IconButton>
                          </TableCell>
                        )}
                      </TableRow>

                      {/* Dynamically Added Rows */}
                      {console.log(appointmentList, "list")}
                      {appointmentList.map((row) => (
                        <TableRow key={row.id}>
                          <TableCell>{row.invoiceNo}</TableCell>
                          <TableCell>{row.billNo}</TableCell>
                          <TableCell>{row.generatedOn}</TableCell>
                          <TableCell>{row.closedOn}</TableCell>
                          <TableCell>
                            {row?.invoice?.totalAmount || "-"}
                          </TableCell>
                          {isEdit && (
                            <TableCell>
                              <IconButton
                                onClick={() => handleRemoveTableRow(row.id)}
                              >
                                <CloseIcon fontSize="small" />
                              </IconButton>
                            </TableCell>
                          )}
                        </TableRow>
                      ))}

                      {/* "Add Item" Row - Visible Only in Edit Mode */}
                      {isEdit && (
                        <TableRow>
                          <TableCell
                            sx={{
                              color: "#92A6CC",
                              cursor: "pointer",
                              textAlign: "left",
                            }}
                            colSpan={6}
                            onClick={handleAddTableRow}
                          >
                            + Add Item
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}

export default PatientAppointments;
